import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import ScrollReveal from '../components/ScrollReveal'
import { getAllPosts } from '../news'
import './NewsList.css'
import '../styles/shared-hero.css'

function NewsList() {
  const posts = getAllPosts()

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  return (
    <>
      <SEO 
        title="News" 
        description="Insights on fractional CTO services, technology leadership, and building engineering teams that scale."
        path="/news"
      />
      
      {/* Hero Section */}
      <section className="blog-hero page-hero">
        <div className="page-hero-content blog-hero-content">
          <ScrollReveal>
            <h1>Insights on <em>technology leadership</em></h1>
          </ScrollReveal>
          <ScrollReveal delay={100}>
            <p className="blog-hero-description">
              Thoughts on fractional CTO services, engineering culture, and building technology organisations.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* News Posts */}
      <section className="blog-posts-section">
        <div className="blog-posts-grid">
          {posts.map((post, index) => (
            <ScrollReveal key={post.slug} delay={index * 100}>
              <article className="blog-post-card">
                <Link to={`/news/${post.slug}`} className="blog-post-link">
                  <div className="blog-post-meta">
                    <time dateTime={post.date}>{formatDate(post.date)}</time>
                  </div>
                  <h2 className="blog-post-title">{post.title}</h2>
                  <p className="blog-post-excerpt">{post.excerpt}</p>
                  <div className="blog-post-tags">
                    {post.tags.map((tag) => (
                      <span key={tag} className="blog-post-tag">{tag}</span>
                    ))}
                  </div>
                  <span className="read-more">Read article →</span>
                </Link>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </section>
    </>
  )
}

export default NewsList
